export default "__VITE_ASSET__CPUCVtSz__"